import BigNumber from 'bignumber.js'
import { numberMoney } from 'Data/format.js'

export function getValue(retail_items, charges) {
  let total_retail = retail_items.reduce(
    (acc, retail_item) => acc.plus(retail_item.amount),
    BigNumber(0)
  )
  let total = charges
    .reduce((acc, charge) => acc.plus(charge.amount), total_retail)
    .decimalPlaces(2)
    .toNumber()
  return numberMoney(total)
}
